import { render, staticRenderFns } from "./welfare-notice.vue?vue&type=template&id=7c4dc0f9&scoped=true&"
import script from "./welfare-notice.vue?vue&type=script&lang=js&"
export * from "./welfare-notice.vue?vue&type=script&lang=js&"
import style0 from "./welfare-notice.vue?vue&type=style&index=0&id=7c4dc0f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4dc0f9",
  null
  
)

export default component.exports